import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { type SelectChangeEvent } from '@mui/material/Select'
import CollectionCompaniesLoader from '@/wrappers/collection-companies-loader'

export default function CollectionCompanySelector({
    collectionCompanyId,
    setCollectionCompanyId,
}: {
    collectionCompanyId,
    setCollectionCompanyId,
}) {

    return (
        <CollectionCompaniesLoader>
            {collectionCompanies => (
                <FormControl sx={{ minWidth: 190, flexGrow: 1, maxWidth: 250 }}>
                    <InputLabel id="collectionCompany-select-label" size='small'>Svozová společnost</InputLabel>
                    <Select
                        labelId="collectionCompany-select-label"
                        label="Svozová společnost"
                        id="roles-select"
                        value={collectionCompanyId}
                        onChange={(e: SelectChangeEvent) => {
                            setCollectionCompanyId(e.target.value)
                        }}
                        input={<OutlinedInput label="Svozová společnost" />}
                        size='small'
                    >
                        <MenuItem key="none" value="">-</MenuItem>
                        {collectionCompanies.sort((a, b) => a.eoko_customer?.name.localeCompare(b.eoko_customer?.name, 'cs', { numeric: true })).map(collectionCompany => (
                            <MenuItem key={collectionCompany.id} value={collectionCompany.id}>{collectionCompany.eoko_customer?.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </CollectionCompaniesLoader>
    )
}
